import { PageScaffold } from "../../shared/ui/PageScaffold";

const adminLinks = [
  { to: "/t/:tenantSlug/teacher/admin", label: "管理ホーム" },
  { to: "/t/:tenantSlug/teacher/admin/integrations", label: "連携設定" }
];

export function AdminPoliciesPage() {
  return (
    <PageScaffold
      title="Admin Policies"
      description="ポリシー設定画面のプレースホルダーです。"
      links={adminLinks}
    >
      <p>ここに tenant policy 設定を表示します。</p>
    </PageScaffold>
  );
}
